/**
 * Public API client для landing, submit и tracked redirect в OKDoc.
 * Дата: 16.03.2026
 */
import axios from "axios";
import type {
  PublicAppointmentActionLanding,
  PublicAppointmentActionSubmitResult,
} from "@/features/okdoc/types";

const publicApiClient = axios.create({
  baseURL: import.meta.env.VITE_API_URL || "/api",
  headers: {
    "Content-Type": "application/json",
  },
});

// 19.03.26 2.: public API для OKDoc landing, submit и tracked redirect.
// Связанный док: docs/living/okdoc/OKDOC_SCENARIOS_FOUNDATION.md
// При изменении public OKDoc API обновляйте и код, и док.
export const publicAppointmentActionsApi = {
  // 19.03.26 2.: получает landing-данные по короткому коду.
  getLanding: async (code: string): Promise<PublicAppointmentActionLanding> => {
    const response = await publicApiClient.get<PublicAppointmentActionLanding>(
      `/public/appointment-actions/${code}`,
    );
    return response.data;
  },

  // 19.03.26 2.: отправляет итоговое действие пациента.
  submit: async (
    code: string,
    action: string,
  ): Promise<PublicAppointmentActionSubmitResult> => {
    const response = await publicApiClient.post<PublicAppointmentActionSubmitResult>(
      `/public/appointment-actions/${code}/submit`,
      { action },
    );
    return response.data;
  },

  // 19.03.26 2.: строит tracked redirect URL через backend.
  getTrackedRedirectUrl: (code: string, target = 'default'): string => {
    const baseURL = import.meta.env.VITE_API_URL || '/api';
    const normalizedBase = baseURL.endsWith('/') ? baseURL.slice(0, -1) : baseURL;
    return `${normalizedBase}/public/appointment-actions/${code}/redirect?target=${encodeURIComponent(target)}`;
  },
};
